const rollDice = (args) => {
  const sides = Math.max(2, parseInt(args[0], 10) || 6)
  const result = Math.floor(Math.random() * sides) + 1
  return { post: `🎲 rolled a **${result}** (d${sides})` }
}

export const COMMANDS = [
  {
    name: 'roll-dice',
    usage: '/roll-dice [sides]',
    description: 'Roll a virtual die, default d6',
    run: rollDice
  },
  {
    name: 'roshambo',
    usage: '/roshambo [username], /roshambo join, /roshambo rock|paper|scissors',
    description: 'Challenge someone (or anyone) in this chat to rock-paper-scissors',
    run: () => ({ local: true })
  },
  {
    name: 'help',
    usage: '/help',
    description: 'List available commands',
    run: () => ({ local: true })
  }
]

const helpText = () =>
  ['Available commands:', ...COMMANDS.map((c) => `${c.usage} — ${c.description}`)].join('\n')

// Returns { post } to send `post` as a real chat message, or { local } to
// show `local` text only to the sender (never sent to the server/socket).
// Returns null when `input` isn't a slash command at all.
export const runSlashCommand = (input) => {
  const trimmed = input.trim()
  if (!trimmed.startsWith('/')) return null

  const [name, ...args] = trimmed.slice(1).split(/\s+/)
  if (name === '') return { local: helpText() }

  const command = COMMANDS.find((c) => c.name === name)
  if (!command) {
    return { local: `Unknown command "/${name}". Type /help for a list of commands.` }
  }

  const result = command.run(args)
  return result.local === true ? { local: helpText() } : result
}
